import React from 'react';
import { BarChart, CartesianGrid, YAxis, XAxis, Tooltip, Bar, Legend, ResponsiveContainer,LabelList } from 'recharts';

const Jobseekersgraph = ({ CandidateAvailability }) => {
  console.log(CandidateAvailability);

  const CustomLegend = ({ payload, data }) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {payload.map((entry, index) => (
          <div key={`legend-${index}`} style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
            <div style={{ backgroundColor: entry.color, width: '10px', height: '10px', borderRadius: '50%', marginRight: '15px' }} />
            <span>{data[index].CountryName}</span>
          </div>
        ))}
      </div>
    );
  };
  
  

  return (
    <>
      {CandidateAvailability && (
        <ResponsiveContainer width="100%" height={350} style={{ marginBottom: '15px' }}>
          <BarChart
            data={CandidateAvailability}
            margin={{
              top: 20,
              bottom: 20,
              right: 40,
              left: 10
            }}
          >
            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
            <YAxis label={{ value: "Total Count", angle: -90, position: "insideLeft" }} fontSize={12} />
            <XAxis dataKey={"CountryName"} fontSize={12} />
            <Tooltip />
            <Bar dataKey={"TotalCount"} barSize={120} fill="#2855A1" >
              <LabelList dataKey="TotalCount" position="top" />
              </Bar>
            <Legend content={<CustomLegend data={CandidateAvailability} />} align="center" verticalAlign="bottom" wrapperStyle={{ bottom: 0, position: 'absolute' }} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default Jobseekersgraph;
